import * as React from "react";
import { LoaderCircle } from "./icons";

import { cn } from "utils/cn";

export interface SpinnerProps {
  className?: string;
  /** Screen-reader text. Pass it when the spinner is the only sign that something is loading. */
  label?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ className, label }) => (
  <span data-ui="spinner" role={label ? "status" : undefined} className="inline-flex">
    <LoaderCircle aria-hidden="true" className={cn("h-4 w-4 animate-spin", className)} />
    {label && <span className="sr-only">{label}</span>}
  </span>
);
